<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile
    },
    created() {
        this.$store.commit('getTaiwan', 'car')
        this.$store.dispatch('getBannerZt', '车')
        this.$store.dispatch('getBannerArticle', '车')
        this.$store.commit('getSubmit', '车')
        this.$store.commit('dataColor', {
            bar0: '#e74c3c',
            bar1: '#c0392b',
            line0: '#3498db',
            line1: '#2980b9'
        })
    },
}
</script>

<style>
#app .nav ul li:last-child {
    display: none;
}

#app .right-box .form .btn:hover {
    color: #fff;
    background-color: #e74c3c;
    border-color: #e74c3c;
}

.company h2::before,
.content-right .platform li:hover,
.move-searchBox,
.report-con .report-title p,
.report-list li a:hover .report-con,
.tsb a:hover span {
    background: #e74c3c;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    color: #e74c3c !important;
    background: #eee !important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover span {
    color: #e74c3c !important;
}

.content-left .title {
    border-left: 5px solid #e74c3c;
}
.content-left .title h2 span {
    color: #e74c3c;
    padding: 0 10px;
}

.content-right .right-title a:hover,
.company-title a:hover,
#app .right-box .form .btn,
.text a:hover span,
.content-left .more a,
.project a:hover p,
.report-list li a:hover .report-title p,
.tsb a:hover p,
.mobile-bottom .current,
.mobile-top .current2,
.mobile-submit i,
.backtop:hover,
.code-box:hover {
    color: #e74c3c;
}

@media(max-width: 868px) {
  .banner-right .banner-right-m p {
    background: #e74c3c;
  }
}
</style>